module.exports = __webpack_public_path__ + "static/media/travel-scout.595d3239.mp4";